import { render } from "./Modal.vue?vue&type=template&id=9b92b070"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render

export default script